import React, { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HomeDashboardLayout from "../HomeDashboardLayout";
import AssessmentPackCard from "./AssessmentPackCard";
import "../../dashboard/Dashboard.css";
import "../HomeDashboard.css";
import "../gamification/Coinstore.css";
import "../questionBank/QuestionBankList.css";
import HeaderProfileSection from "../HeaderProfileSection";
import MyWalletSidebar from "../MyWalletSidebar";
import assesmntIcon from "../../assets/images/b1.png";
import { useQuizReattempts } from "../../hooks/useQuizReattempts";
import { SUBSCRIPTION_ROUTES } from "./subscriptionRoutes";
import { fetchPaymentGateways } from "../../services/coinPurchaseService";
import { createAssessmentOrder } from "../../services/subscriptionService";

const AssessmentAttempt = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data, isLoading, isFetching, isError, error, refetch } = useQuizReattempts();
  const isPending = isLoading || isFetching;
  const slug = location.state?.subscriptionSlug || location.state?.subscription?.slug || 'purchase-assessment-reattempts';
  const [buyingPackId, setBuyingPackId] = useState(null);
  const [purchaseError, setPurchaseError] = useState('');
  const purchaseInProgress = useRef(false);

  const buyPack = async (pack) => {
    if (purchaseInProgress.current) return;
    purchaseInProgress.current = true;
    setBuyingPackId(pack.id);
    setPurchaseError('');
    try {
      const gateways = await fetchPaymentGateways();
      if (!gateways.length) throw new Error('Payment methods are currently unavailable.');
      const assessmentOrder = await createAssessmentOrder(pack);
      navigate(SUBSCRIPTION_ROUTES.paymentMethod, {
        state: {
          ...location.state, subscriptionSlug: slug, reattemptPack: pack, assessmentOrder,
          paymentGateways: gateways, returnPath: SUBSCRIPTION_ROUTES.assessmentReattempts
        },
      });
    } catch (purchaseFailure) {
      setPurchaseError(purchaseFailure.message || 'Unable to prepare assessment attempt purchase.');
    } finally {
      purchaseInProgress.current = false;
      setBuyingPackId(null);
    }
  };

  return (
    <>
      <style>{`
          .homeDashboard-wrapper .page-content {
            padding-right: 0;
          }
      .homeDashboard-wrapper .main-content {
          height: 100vh;
          overflow: hidden;
          box-sizing: border-box;
          padding-bottom: 35px;
          min-height:0;
          
        }
      
      `}</style>
      <HomeDashboardLayout showHeader={false}>
        <div className="qbl-page qbankList-page page-padding start-gamification ">
          <div className="start-quiz qbl-main  instruction-main">
            <div className="hideProfile-page ">
              {/* Page header */}
              <div className="categories-page-header mb-0">
                <div>
                  <button
                    type="button"
                    className="categories-back-button"
                    onClick={() => navigate(-1)}>
                    <i className="bi bi-chevron-left"></i>
                  </button>
                </div>
                <div>
                  <h4 className="d-flex categories-page-title"> </h4>
                </div>
                <div>
                  <HeaderProfileSection />
                </div>
              </div>
            </div>



            {/* Coin Store Header */}
            <div className="coine-balance-wrapper">

              {/* Header */}
              <div className="rapid-fire-header">
                <h1 className="qb-title"> Assessment  {" "} <span>Attempts</span></h1>
              </div>

              {/* Description */}
              <p className="game-description">
                Complete, Learn & improve Daily
              </p>


              {/* Balance Section */}
              <div className="coine-balance-header coin-wrap">
                {/* <div className="coine-balance-icon">
          <span>₵</span>
        </div> */}
                <div className="coine-balance-iconn">
                  <img src={assesmntIcon} alt="" />
                </div>
                <div className="coine-balance-info">
                  <div className="coine-balance-label">Remaining Attempts</div>
                  <div className="coine-balance-value">
                    {isPending
                      ? <span className="dashboard-skeleton dashboard-skeleton--line" style={{ display: 'inline-block', width: 48, height: 24 }} aria-label="Loading remaining attempts" />
                      : <span>{isError ? '—' : data?.remainingAttempts ?? 0}</span>} Attempts
                  </div>
                </div>
              </div>

              {/* Earn Coins Section */}

            </div>

            {/* Coin Store Pack Card */}
            {/* Coin Store Pack Card */}
            {purchaseError ? <p className="choose-state__status choose-state__status--error" role="alert">{purchaseError}</p> : null}
            <AssessmentPackCard
              packs={data?.packs || []}
              isLoading={isPending}
              isError={isError}
              error={error}
              onRetry={refetch}
              onBuy={buyPack}
              buyingPackId={buyingPackId}
              loadingCount={6}
              packType="assessment attempt"
              heading="Buy Reattempt Addons"
              description="Choose extra assessment attempts for uninterrupted practice"
            />

          </div>
          <MyWalletSidebar withTopOffset={false} />
        </div>
      </HomeDashboardLayout>
    </>
  );
};

export default AssessmentAttempt;
